<template>
  <RunCard
    class="OnboardingRunPreview"
    :canNavigate="false"
    excludeAvatarList
    v-bind="{run}"
  >
    <template #actions>
      <RunStatusButtonList
        v-model="modelValue"
        class="OnboardingRunPreview__statusButtonList"
      />
    </template>
  </RunCard>
</template>

<script lang="ts" setup>
import RunCard from "@/components/RunCard.vue";
import { RunForCarousel } from "@/stores/useRunCarouselStore";
import RunStatusButtonList from "@/views/RunStatusButtonList.vue";
import { addHours, set, startOfTomorrow } from "date-fns";
import { computed } from "vue";

const modelValue = defineModel<number | null>({
  required: true,
});

const startAt = set(startOfTomorrow(), {
  hours: 8,
  minutes: 0,
  seconds: 0,
  milliseconds: 0,
});

const run = computed(() => {
  return {
    id: "onboarding-demo-run",
    start_at: startAt.toISOString(),
    end_at: addHours(startAt, 2).toISOString(),
    canceled_at: null,
    rsvp_at: null,
    season_id: null,
    court: {
      id: "onboarding-demo-court",
      name: "Brooklyn Bridge Park",
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      photo_blurhash: "LnDmROxZa{t7TOj[oeofIxbJoLWB",
      photo_storage_path: "/images/onboarding/brooklyn-bridge-park.webp",
    },
    crews: [
      {
        id: "onboarding-demo-crew",
        name: "Brooklyn Hoops",
        location: "New York, NY",
        players: [],
      },
    ],
    statuses: [],
    sub_requests: [],
    season: null,
    awards: [],
    reviews: [],
    award_winners: [],
  } as unknown as RunForCarousel;
});
</script>

<style lang="scss" scoped>
.OnboardingRunPreview {
  width: 100%;
  max-width: 340px;
  margin-inline: auto;
}

.OnboardingRunPreview__statusButtonList {
  padding: 14px 12px;
}
</style>
